import { apiGet, apiPost } from './index'

export type BillingEligibility = {
  station_id: number
  is_admin: boolean
  has_admins: boolean
  can_purchase: boolean
}

export type CheckoutRequest = {
  plan: string
  station_id?: number
  seat_quantity?: number
  quantity?: number
  currency?: string
  owner_type?: 'user' | 'station'
}

export type CheckoutResponse = {
  id: string
  url: string
}

export type PortalResponse = {
  url: string
}

export type BillingSummaryItem = {
  price_id: string
  plan_key: string
  label: string
  type: 'base' | 'seat' | 'addon' | string
  quantity: number
  currency: string
  unit_amount: number | null
  line_total: number | null
  interval: string | null
  interval_count: number | null
}

export type BillingSubscriptionSummary = {
  id: number
  stripe_subscription_id: string
  status: string
  current_period_end: string | null
  trial_end: string | null
  cancel_at_period_end: boolean
  currency: string | null
  total_amount: number | null
  interval: string | null
  interval_count: number | null
  items: BillingSummaryItem[]
}

export type BillingSummaryStation = {
  id: number
  name: string
  role: string
  is_admin: boolean
  subscriptions: BillingSubscriptionSummary[]
}

export type BillingSummaryResponse = {
  user: {
    subscriptions: BillingSubscriptionSummary[]
  }
  stations: BillingSummaryStation[]
}

export function getStationEligibility(stationId: number): Promise<BillingEligibility> {
  return apiGet<BillingEligibility>(`billing/stations/eligibility?station_id=${stationId}`)
}

export function createCheckout(payload: CheckoutRequest): Promise<CheckoutResponse> {
  return apiPost<CheckoutResponse>('billing/checkout', payload)
}

export function createPortal(params: { customer_type?: 'user' | 'station'; station_id?: number }): Promise<PortalResponse> {
  const search = new URLSearchParams()
  if (params.customer_type) {
    search.set('customer_type', params.customer_type)
  }
  if (params.station_id) {
    search.set('station_id', String(params.station_id))
  }
  const path = `billing/portal?${search.toString()}`
  return apiGet<PortalResponse>(path)
}

export function getBillingSummary(): Promise<BillingSummaryResponse> {
  return apiGet<BillingSummaryResponse>('billing/summary')
}
